import { Box, Text, Center, Grid, GridItem, VStack } from '@chakra-ui/react';
import Draggable from 'react-draggable';

export interface GameOverWindowProps {
  scoreMs: number;
  onDismiss: () => void;
}

/**
 * Small OS-style result panel (Credits-like chrome).
 * Any click / tap on the panel dismisses and returns home.
 */
const GameOverWindow = ({ scoreMs, onDismiss }: GameOverWindowProps) => {
  return (
    <>
      {/* Full-screen catch for click / tap outside the panel */}
      <Box
        className="arcade-gameover-backdrop"
        position="fixed"
        inset={0}
        zIndex={19}
        bg="transparent"
        onClick={onDismiss}
        onTouchEnd={(event) => {
          event.preventDefault();
          onDismiss();
        }}
      />
      <Draggable handle="#gameOverTopBar" bounds="body" cancel="#gameOverWindowControl">
        <Box
          className="arcade-gameover-window"
          w="300px"
          h="220px"
          bg="#393E46"
          top="calc(50% - 110px)"
          left="calc(50% - 150px)"
          position="fixed"
          border="2px solid black"
          borderRadius="4px"
          outline="2px solid black"
          outlineOffset="-6px"
          opacity="0.95"
          boxShadow="5px 10px #0C0C0C"
          zIndex={20}
          onClick={onDismiss}
          cursor="pointer"
          userSelect="none"
        >
          <Box id="gameOverTopBar" w="100%" h="25px" bg="transparent">
            <Grid w="100%" h="100%" templateColumns="repeat(6, 1fr)">
              <GridItem colSpan={1} cursor="move" />
              <GridItem colSpan={4} h="25px" cursor="move">
                <Center w="100%" h="100%">
                  <Text fontSize="16px" fontFamily="BasedPixel" color="#e9ebf1">
                    GAME OVER
                  </Text>
                </Center>
              </GridItem>
              <GridItem
                id="gameOverWindowControl"
                colSpan={1}
                h="25px"
                onClick={(event) => {
                  event.stopPropagation();
                  onDismiss();
                }}
              >
                <Center w="100%" h="100%">
                  <Text
                    fontSize="16px"
                    fontFamily="BasedPixel"
                    fontWeight="bold"
                    color="#e9ebf1"
                    _hover={{
                      color: 'blue',
                    }}
                  >
                    X
                  </Text>
                </Center>
              </GridItem>
            </Grid>
          </Box>
          <VStack
            align="stretch"
            spacing={2}
            fontSize="15px"
            fontFamily="BasedPixel"
            fontWeight="semibold"
            px="16px"
            pt="6px"
            color="#e9ebf1"
          >
            <Text textAlign="center" fontSize="18px" letterSpacing="0.06em">
              MISSION FAILED
            </Text>
            <Text
              textAlign="center"
              fontSize="28px"
              color="#f9f7c9"
              letterSpacing="0.04em"
              mt="-2px"
              lineHeight="1.1"
            >
              {scoreMs.toLocaleString()}
            </Text>
            <Text textAlign="center" color="#aad9bb" mt="-2px">
              SCORE
            </Text>
            <Text textAlign="center" fontSize="12px" color="#9aa0a6" pt="4px" opacity={0.9}>
              tap / click / space to continue
            </Text>
          </VStack>
        </Box>
      </Draggable>
    </>
  );
};

export default GameOverWindow;
